export const login = {
  /**
   * 取得登入跳轉頁面資訊
   * @param {object} history - 瀏覽器歷史紀錄物件
   */
  getLoginPageInfo(history, constructionUuid) {
    const state =
      history.location.state ||
      (!history.location.pathname.startsWith("/Login") ? { from: history.location } : null);

    return {
      pathname: history.location.pathname.startsWith("/Login")
        ? history.location.pathname
        : `/Login/${constructionUuid || ""}`,
      state: state
    };
  },
  /**
   * 轉跳頁面至登入頁面並記錄目前頁面為登入前的目標頁面
   * @param {object} history - 瀏覽器歷史紀錄物件
   */
  goLoginPage(history, constructionUuid) {
    history.push(login.getLoginPageInfo(history, constructionUuid));
  },
  /**
   * 跳轉頁面回登入前的目標頁面
   * @param {object}} history - 瀏覽器歷史紀錄物件
   */
  goRedirectPage(history) {
    const { from } = history.location.state || { from: { pathname: "/" } };
    history.replace(from);
  }
};
